import popupStyles from "../generalSuccessPopup/generalSuccessPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { Link } from "react-router-dom";
import { tWithKeyAttr as t } from "../../../i18nHelper";


function InactivityLogoutPopup({ onClose }: IPopupWithoutProps) {
  return (
    <article className={popupStyles.popup}>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <p className={`title title_blue`}>{t('LOGOUT_NOTIFICATION_TITLE')}</p>
      <p className={popupStyles.popup__text}>
        {t('LOGOUT_AUTOMATICALLY_NOTICE')}{" "}
      </p>
      <Link
        to={"/"}
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
      >{t('RETURN_TO_SITE')}</Link>
    </article>
  );
}

export default InactivityLogoutPopup;
